import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21.7,10l-9-8c-0.4-0.3-0.9-0.3-1.3,0l-9,8c-0.4,0.4-0.5,1-0.1,1.4c0.2,0.2,0.5,0.3,0.7,0.3h1v9c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1v-9h1c0.6,0,1-0.4,1-1C22,10.4,21.9,10.2,21.7,10z M15,19.7H9v-3c0-1.7,1.3-3,3-3s3,1.3,3,3V19.7z" }, null, -1)
  ])))
}
export default { render: render }